export default "__VITE_ASSET__BZm_5BFf__"